/**
 * @deprecated use `getValidLocale` from '@mentimeter/i18n-core' wherever possible.
 */
export function resolveLocale(locale: string, locales: string[]) {
  return locales.find((l) => l.toLowerCase() === locale.toLowerCase());
}

export function fetchLocaleFromPathname(pathname: string, locales: string[]) {
  // /en-US/foo/bar -> en-US (VALID)
  // /en-us/foo/bar -> en-US (VALID)
  // /foo/bar -> foo (INVALID)
  const locale = pathname.split('/')[1];

  if (!locale) {
    return;
  }

  return resolveLocale(locale, locales);
}

export function getPathnameWithoutLocale(pathname: string, locales: string[]) {
  const existingLocale = fetchLocaleFromPathname(pathname, locales); // one of locales, null if no locale in path

  if (!existingLocale || !locales.includes(existingLocale)) {
    // there's no locale
    return pathname;
  }

  return '/' + pathname.split('/').slice(2).join('/');
}
